/** First-party PostHog proxy path — forwarded to us.i.posthog.com via Netlify redirects or the Vite dev proxy. */
export const getPostHogApiHost = (): string => '/ingest';
